import { List } from 'immutable';
import { ensure } from '../../../utils/arrayUtils';
import LanguageUtils from '../../../utils/LanguageUtils';
import ValidationModel from '../../../utils/validationModel';
import ValidationUtils from '../../../utils/validationUtils';

const messages = {
    requiredFields: LanguageUtils.createMessage('Agreement is required')
};

export default class AddAgreementStep2Validation extends ValidationUtils {
    static validateSelectedAgreement(agreementId?: number): boolean {
        return !!agreementId;
    }

    static validateAddAgreementForm(agreementId?: number): ValidationModel {
        const validationModel = {
            validationMessages: List(),
            isValid: true
        } as ValidationModel;

        const requiredFields = AddAgreementStep2Validation.validateSelectedAgreement(agreementId);

        if(!requiredFields) {
            validationModel.isValid = false;
            validationModel.validationMessages = ensure(validationModel.validationMessages).push(messages.requiredFields);
        }

        return validationModel;
    }
}
